import { translateText } from "../i18n";

export const LANGUAGE_STORAGE_KEY = "xima_ui_language";

export const LANGUAGE_OPTIONS = [
  {
    value: "es",
    shortLabel: "ES",
    nativeLabel: "Español",
    label: {
      es: "Español",
      en: "Spanish",
      ru: "Испанский",
      de: "Spanisch",
    },
    description: {
      es: "Interfaz en español",
      en: "Interface in Spanish",
      ru: "Интерфейс на испанском",
      de: "Oberflaeche auf Spanisch",
    },
  },
  {
    value: "en",
    shortLabel: "EN",
    nativeLabel: "English",
    label: {
      es: "Ingles",
      en: "English",
      ru: "Английский",
      de: "Englisch",
    },
    description: {
      es: "Interfaz en ingles",
      en: "Interface in English",
      ru: "Интерфейс на английском",
      de: "Oberflaeche auf Englisch",
    },
  },
  {
    value: "ru",
    shortLabel: "RU",
    nativeLabel: "Русский",
    label: {
      es: "Ruso",
      en: "Russian",
      ru: "Русский",
      de: "Russisch",
    },
    description: {
      es: "Interfaz en ruso",
      en: "Interface in Russian",
      ru: "Интерфейс на русском",
      de: "Oberflaeche auf Russisch",
    },
  },
  {
    value: "de",
    shortLabel: "DE",
    nativeLabel: "Deutsch",
    label: {
      es: "Aleman",
      en: "German",
      ru: "Немецкий",
      de: "Deutsch",
    },
    description: {
      es: "Interfaz en aleman",
      en: "Interface in German",
      ru: "Интерфейс на немецком",
      de: "Oberflaeche auf Deutsch",
    },
  },
];

const SUPPORTED_LANGUAGES = new Set(LANGUAGE_OPTIONS.map((option) => option.value));

const LANGUAGE_LOCALES = {
  es: "es-ES",
  en: "en-US",
  ru: "ru-RU",
  de: "de-DE",
};

const EXTRA_TRANSLATIONS = {
  Accept: { ru: "Принять", de: "Annehmen" },
  "Accept and play": { ru: "Принять и играть", de: "Annehmen und spielen" },
  "AI-style visual collection. Each pack includes block art and premium frame.": {
    ru: "Коллекция в AI-стиле. Каждый набор включает арт блока и премиальную рамку.",
    de: "Visuelle Kollektion im KI-Stil. Jedes Paket enthaelt Block-Art und einen Premium-Rahmen.",
  },
  Animations: { ru: "Анимации", de: "Animationen" },
  "Auto-join last mode": { ru: "Автовход в последний режим", de: "Letzten Modus automatisch starten" },
  "Automatic send failed": { ru: "Автоотправка не удалась", de: "Automatisches Senden fehlgeschlagen" },
  "Avg duration": { ru: "Средняя длительность", de: "Durchschnittsdauer" },
  "Back to Friends": { ru: "Назад к друзьям", de: "Zurueck zu Freunden" },
  "Back to Lobby": { ru: "Назад в лобби", de: "Zurueck zur Lobby" },
  "Basic Rules": { ru: "Основные правила", de: "Grundregeln" },
  "Best streak": { ru: "Лучшая серия", de: "Beste Serie" },
  Cancel: { ru: "Отмена", de: "Abbrechen" },
  "Cancel invite": { ru: "Отменить приглашение", de: "Einladung abbrechen" },
  "Captured blocks": { ru: "Захваченные блоки", de: "Eroberte Bloecke" },
  "Check that backend is running.": {
    ru: "Проверьте, что backend запущен.",
    de: "Pruefe, ob das Backend aktiv ist.",
  },
  Code: { ru: "Код", de: "Code" },
  "Code copied": { ru: "Код скопирован", de: "Code kopiert" },
  "Code required": { ru: "Нужен код", de: "Code erforderlich" },
  "Compact right panel": { ru: "Компактная правая панель", de: "Kompaktes rechtes Panel" },
  "Complete the form": { ru: "Заполните форму", de: "Formular ausfuellen" },
  "Configure language, support and game preferences.": {
    ru: "Настройте язык, поддержку и игровые параметры.",
    de: "Konfiguriere Sprache, Support und Spieleinstellungen.",
  },
  "Consecutive days playing": { ru: "Дней подряд в игре", de: "Aufeinanderfolgende Spieltage" },
  "Could not accept": { ru: "Не удалось принять", de: "Konnte nicht angenommen werden" },
  "Could not cancel": { ru: "Не удалось отменить", de: "Konnte nicht abgebrochen werden" },
  "Could not decline": { ru: "Не удалось отклонить", de: "Konnte nicht abgelehnt werden" },
  "Could not deny": { ru: "Не удалось отклонить", de: "Konnte nicht verweigert werden" },
  "Could not invite": { ru: "Не удалось пригласить", de: "Konnte nicht einladen" },
  "Could not join": { ru: "Не удалось присоединиться", de: "Konnte nicht beitreten" },
  "Could not load friend profile.": {
    ru: "Не удалось загрузить профиль друга.",
    de: "Freundesprofil konnte nicht geladen werden.",
  },
  "Could not load Friends": { ru: "Не удалось загрузить друзей", de: "Freunde konnten nicht geladen werden" },
  "Could not send request": { ru: "Не удалось отправить запрос", de: "Anfrage konnte nicht gesendet werden" },
  "Customize your experience with AI-style special block designs and discover the official board game.": {
    ru: "Настройте свой опыт с AI-стилем для особых блоков и познакомьтесь с официальной настольной игрой.",
    de: "Passe dein Erlebnis mit KI-inspirierten Spezialblock-Designs an und entdecke das offizielle Brettspiel.",
  },
  "Day streak": { ru: "Серия дней", de: "Tagesserie" },
  "Default values were restored.": {
    ru: "Значения по умолчанию восстановлены.",
    de: "Standardwerte wurden wiederhergestellt.",
  },
  Deny: { ru: "Отклонить", de: "Ablehnen" },
  "Describe your issue...": { ru: "Опишите проблему...", de: "Beschreibe dein Problem..." },
  Decline: { ru: "Отклонить", de: "Ablehnen" },
  Draw: { ru: "Ничья", de: "Unentschieden" },
  Duration: { ru: "Длительность", de: "Dauer" },
  "Ended": { ru: "Завершено", de: "Beendet" },
  "Enter the player's code to search.": {
    ru: "Введите код игрока для поиска.",
    de: "Gib den Spielercode fuer die Suche ein.",
  },
  "Entering match...": { ru: "Вход в матч...", de: "Trete dem Match bei..." },
  "Ex: XIMA-4821": { ru: "Пример: XIMA-4821", de: "Bsp.: XIMA-4821" },
  "Find player by code": { ru: "Найти игрока по коду", de: "Spieler per Code finden" },
  Friend: { ru: "Друг", de: "Freund" },
  "Friend profile": { ru: "Профиль друга", de: "Freundesprofil" },
  "Friend request was sent.": { ru: "Запрос в друзья отправлен.", de: "Freundesanfrage wurde gesendet." },
  "Friend room is not available.": { ru: "Комната друга недоступна.", de: "Der Raum des Freundes ist nicht verfuegbar." },
  Friends: { ru: "Друзья", de: "Freunde" },
  "Friends list": { ru: "Список друзей", de: "Freundesliste" },
  "Game invite was sent.": { ru: "Игровое приглашение отправлено.", de: "Spieleinladung wurde gesendet." },
  "Game sound": { ru: "Звук игры", de: "Spielsound" },
  General: { ru: "Общие", de: "Allgemein" },
  "General Preferences": { ru: "Общие настройки", de: "Allgemeine Einstellungen" },
  "Here is the official content to study XIMA: How to Reach the Top, Scientific XIMA, and the Play Xima YouTube channel.": {
    ru: "Здесь собран официальный контент для изучения XIMA: How to Reach the Top, Scientific XIMA и YouTube-канал Play Xima.",
    de: "Hier findest du die offiziellen Inhalte zum Lernen von XIMA: How to Reach the Top, Scientific XIMA und den Play Xima YouTube-Kanal.",
  },
  "How to Play XIMA": { ru: "Как играть в XIMA", de: "So spielt man XIMA" },
  "In match": { ru: "В матче", de: "Im Match" },
  Incoming: { ru: "Входящие", de: "Eingehend" },
  "Incoming invites": { ru: "Входящие приглашения", de: "Eingehende Einladungen" },
  "Incoming request": { ru: "Входящий запрос", de: "Eingehende Anfrage" },
  Invite: { ru: "Пригласить", de: "Einladen" },
  "Invite accepted": { ru: "Приглашение принято", de: "Einladung angenommen" },
  "Invite canceled": { ru: "Приглашение отменено", de: "Einladung abgebrochen" },
  "Invite denied": { ru: "Приглашение отклонено", de: "Einladung abgelehnt" },
  "Invite sent": { ru: "Приглашение отправлено", de: "Einladung gesendet" },
  "Invite was declined.": { ru: "Приглашение было отклонено.", de: "Die Einladung wurde abgelehnt." },
  Join: { ru: "Присоединиться", de: "Beitreten" },
  Language: { ru: "Язык", de: "Sprache" },
  "Learn XIMA": { ru: "Изучать XIMA", de: "XIMA lernen" },
  "Learning Center": { ru: "Центр обучения", de: "Lernzentrum" },
  Loading: { ru: "Загрузка", de: "Laden" },
  "Loading...": { ru: "Загрузка...", de: "Laedt..." },
  Loss: { ru: "Поражение", de: "Niederlage" },
  Losses: { ru: "Поражения", de: "Niederlagen" },
  "Main objective:": { ru: "Главная цель:", de: "Hauptziel:" },
  "Manual copy": { ru: "Скопируйте вручную", de: "Manuell kopieren" },
  Matches: { ru: "Матчи", de: "Partien" },
  "Message sent": { ru: "Сообщение отправлено", de: "Nachricht gesendet" },
  min: { ru: "мин", de: "Min" },
  Mode: { ru: "Режим", de: "Modus" },
  "No": { ru: "Нет", de: "Nein" },
  "No active room to join.": { ru: "Нет активной комнаты для входа.", de: "Kein aktiver Raum zum Beitreten." },
  "No invites sent yet.": { ru: "Вы еще не отправляли приглашения.", de: "Noch keine Einladungen gesendet." },
  "No outgoing pending requests.": { ru: "Нет исходящих запросов.", de: "Keine ausgehenden offenen Anfragen." },
  "No pending invites.": { ru: "Нет ожидающих приглашений.", de: "Keine offenen Einladungen." },
  "No pending requests.": { ru: "Нет ожидающих запросов.", de: "Keine offenen Anfragen." },
  "No player exists with that code.": { ru: "Игрок с таким кодом не найден.", de: "Es gibt keinen Spieler mit diesem Code." },
  "No relation": { ru: "Нет связи", de: "Keine Beziehung" },
  "Not active yet": { ru: "Пока не активна", de: "Noch nicht aktiv" },
  "Not found": { ru: "Не найдено", de: "Nicht gefunden" },
  Off: { ru: "Выкл", de: "Aus" },
  "Official Rules": { ru: "Официальные правила", de: "Offizielle Regeln" },
  "Official Store": { ru: "Официальный магазин", de: "Offizieller Store" },
  "Official YouTube Channels": { ru: "Официальные YouTube-каналы", de: "Offizielle YouTube-Kanaele" },
  "Official physical version to play at home, practice strategy, and share with friends.": {
    ru: "Официальная физическая версия для игры дома, тренировки стратегии и матчей с друзьями.",
    de: "Offizielle physische Version zum Spielen zu Hause, zum Strategie-Training und zum Teilen mit Freunden.",
  },
  "Online": { ru: "Онлайн", de: "Online" },
  Offline: { ru: "Не в сети", de: "Offline" },
  "Online mode win rate": { ru: "Винрейт по онлайн-режимам", de: "Siegquote pro Online-Modus" },
  On: { ru: "Вкл", de: "An" },
  "Open Resource": { ru: "Открыть ресурс", de: "Ressource oeffnen" },
  Options: { ru: "Опции", de: "Optionen" },
  "Options to customize your experience.": {
    ru: "Параметры для настройки вашего опыта.",
    de: "Optionen, um dein Erlebnis anzupassen.",
  },
  Outgoing: { ru: "Исходящие", de: "Ausgehend" },
  "Outgoing invites": { ru: "Исходящие приглашения", de: "Ausgehende Einladungen" },
  "Pending invite was canceled.": { ru: "Ожидающее приглашение отменено.", de: "Offene Einladung wurde abgebrochen." },
  "Pending request was removed.": { ru: "Ожидающий запрос удален.", de: "Offene Anfrage wurde entfernt." },
  "Profile error": { ru: "Ошибка профиля", de: "Profilfehler" },
  "Recent matches": { ru: "Последние матчи", de: "Letzte Partien" },
  Refresh: { ru: "Обновить", de: "Aktualisieren" },
  "Recommended Study Path": { ru: "Рекомендуемый путь обучения", de: "Empfohlener Lernpfad" },
  "Report bugs or request help from the team.": {
    ru: "Сообщайте об ошибках или просите помощи у команды.",
    de: "Melde Bugs oder bitte das Team um Hilfe.",
  },
  Requests: { ru: "Запросы", de: "Anfragen" },
  Reset: { ru: "Сбросить", de: "Zuruecksetzen" },
  "Request accepted": { ru: "Запрос принят", de: "Anfrage angenommen" },
  "Request canceled": { ru: "Запрос отменен", de: "Anfrage abgebrochen" },
  "Request denied": { ru: "Запрос отклонен", de: "Anfrage abgelehnt" },
  "Request sent": { ru: "Запрос отправлен", de: "Anfrage gesendet" },
  "Room created. Entering match...": {
    ru: "Комната создана. Входим в матч...",
    de: "Raum erstellt. Match wird betreten...",
  },
  "Rules of XIMA": { ru: "Правила XIMA", de: "Regeln von XIMA" },
  Search: { ru: "Искать", de: "Suchen" },
  "Search by code, send requests, accept friendships, and invite or join matches.": {
    ru: "Ищите по коду, отправляйте запросы, принимайте друзей и приглашайте или присоединяйтесь к матчам.",
    de: "Suche per Code, sende Anfragen, bestaetige Freundschaften und lade zu Matches ein oder tritt ihnen bei.",
  },
  Searching: { ru: "Поиск", de: "Suche" },
  "Searching...": { ru: "Поиск...", de: "Suche..." },
  "Save Settings": { ru: "Сохранить настройки", de: "Einstellungen speichern" },
  Send: { ru: "Отправить", de: "Senden" },
  Sending: { ru: "Отправка", de: "Senden" },
  "Sending...": { ru: "Отправка...", de: "Wird gesendet..." },
  "Select the language for the full interface.": {
    ru: "Выберите язык для всего интерфейса.",
    de: "Waehle die Sprache fuer die gesamte Oberflaeche.",
  },
  "Send friend request": { ru: "Отправить запрос в друзья", de: "Freundesanfrage senden" },
  "Settings": { ru: "Настройки", de: "Einstellungen" },
  "Settings reset": { ru: "Настройки сброшены", de: "Einstellungen zurueckgesetzt" },
  "Settings saved": { ru: "Настройки сохранены", de: "Einstellungen gespeichert" },
  Social: { ru: "Социальное", de: "Soziales" },
  "Special captures": {
    ru: "\u0417\u0430\u0445\u0432\u0430\u0447\u0435\u043d\u043d\u044b\u0435 \u0441\u043f\u0435\u0446\u0438\u0430\u043b\u044c\u043d\u044b\u0435 \u0431\u043b\u043e\u043a\u0438",
    de: "Spezialeroberungen",
  },
  "Special Block Skins": { ru: "Скины спецблоков", de: "Spezialblock-Skins" },
  Status: { ru: "Статус", de: "Status" },
  Subject: { ru: "Тема", de: "Betreff" },
  Support: { ru: "Поддержка", de: "Support" },
  "Support email:": { ru: "Email поддержки:", de: "Support-E-Mail:" },
  "The ad-free subscription will be enabled soon.": {
    ru: "Подписка без рекламы скоро будет доступна.",
    de: "Das werbefreie Abo wird bald verfuegbar sein.",
  },
  "The request was rejected.": { ru: "Запрос был отклонен.", de: "Die Anfrage wurde abgelehnt." },
  "This is you": { ru: "Это вы", de: "Das bist du" },
  "This player has no recorded matches yet.": {
    ru: "У этого игрока пока нет записанных матчей.",
    de: "Dieser Spieler hat noch keine aufgezeichneten Partien.",
  },
  Time: { ru: "Время", de: "Zeit" },
  "Total play time": { ru: "Общее время игры", de: "Gesamtspielzeit" },
  "Try again.": { ru: "Попробуйте снова.", de: "Versuche es erneut." },
  Unavailable: { ru: "Недоступно", de: "Nicht verfuegbar" },
  User: { ru: "Пользователь", de: "Benutzer" },
  "User:": { ru: "Пользователь:", de: "Benutzer:" },
  "Video Tutorials": { ru: "Видеоуроки", de: "Video-Tutorials" },
  "View Product": { ru: "Открыть товар", de: "Produkt ansehen" },
  "View profile": { ru: "Профиль", de: "Profil ansehen" },
  "Watch on YouTube": { ru: "Смотреть на YouTube", de: "Auf YouTube ansehen" },
  Win: { ru: "Победа", de: "Sieg" },
  "Win rate": { ru: "Винрейт", de: "Siegquote" },
  "Win streak": { ru: "Серия побед", de: "Siegesserie" },
  Wins: { ru: "Победы", de: "Siege" },
  "XIMA Board Game": { ru: "Настольная игра XIMA", de: "XIMA Brettspiel" },
  "XIMA Plus Subscription": { ru: "Подписка XIMA Plus", de: "XIMA Plus Abo" },
  "XIMA Store": { ru: "Магазин XIMA", de: "XIMA Store" },
  Yes: { ru: "Да", de: "Ja" },
  "You are now friends.": { ru: "Теперь вы друзья.", de: "Ihr seid jetzt Freunde." },
  "You do not have friends yet.": { ru: "У вас пока нет друзей.", de: "Du hast noch keine Freunde." },
  "Your friend accepted the invite": { ru: "Друг принял приглашение", de: "Dein Freund hat die Einladung angenommen" },
  "Your friends and invites": { ru: "Ваши друзья и приглашения", de: "Deine Freunde und Einladungen" },
  "Your player code": { ru: "Ваш код игрока", de: "Dein Spielercode" },
  "Your preferences were updated.": {
    ru: "Ваши предпочтения обновлены.",
    de: "Deine Einstellungen wurden aktualisiert.",
  },
  "You must add subject and description before sending.": {
    ru: "Перед отправкой укажите тему и описание.",
    de: "Vor dem Senden musst du Betreff und Beschreibung angeben.",
  },
  "Could not load live matches.": {
    ru: "Не удалось загрузить прямые матчи.",
    de: "Live-Matches konnten nicht geladen werden.",
  },
  "Could not load stats.": {
    ru: "Не удалось загрузить статистику.",
    de: "Statistiken konnten nicht geladen werden.",
  },
  Error: { ru: "Ошибка", de: "Fehler" },
  "Entering...": { ru: "Вход...", de: "Beitritt..." },
  "Connected players": { ru: "Подключенные игроки", de: "Verbundene Spieler" },
  "Live online rooms. Join as a spectator.": {
    ru: "Активные онлайн-комнаты. Войдите как зритель.",
    de: "Live-Online-Raeume. Trete als Zuschauer bei.",
  },
  "No player data": { ru: "Нет данных об игроках", de: "Keine Spielerdaten" },
  "Online Match": { ru: "Онлайн-матч", de: "Online-Match" },
  Players: { ru: "Игроки", de: "Spieler" },
  Refreshing: { ru: "Обновление", de: "Aktualisierung" },
  "Refreshing...": { ru: "Обновление...", de: "Wird aktualisiert..." },
  Spectators: { ru: "Зрители", de: "Zuschauer" },
  "There are no active online matches right now.": {
    ru: "Сейчас нет активных онлайн-матчей.",
    de: "Derzeit gibt es keine aktiven Online-Matches.",
  },
  "Watch Matches": { ru: "Смотреть матчи", de: "Matches sehen" },
  "Watch live": { ru: "Смотреть", de: "Live ansehen" },
  
  "Performance summary for your recent matches.": {
    ru: "\u0421\u0432\u043e\u0434\u043a\u0430 \u044d\u0444\u0444\u0435\u043a\u0442\u0438\u0432\u043d\u043e\u0441\u0442\u0438 \u0432\u0430\u0448\u0438\u0445 \u043d\u0435\u0434\u0430\u0432\u043d\u0438\u0445 \u0438\u0433\u0440",
    de: "Leistungsuebersicht deiner letzten Partien.",
  },
  "Go to History": { ru: "\u041f\u0435\u0440\u0435\u0439\u0442\u0438 \u043a \u0438\u0441\u0442\u043e\u0440\u0438\u0438", de: "Zum Verlauf" },
  "Tournaments won by mode": {
    ru: "\u0422\u0443\u0440\u043d\u0438\u0440\u044b, \u0432\u044b\u0438\u0433\u0440\u0430\u043d\u043d\u044b\u0435 \u043f\u043e \u0440\u0435\u0436\u0438\u043c\u0430\u043c",
    de: "Gewonnene Turniere nach Modus",
  },
  "Total tournaments won": {
    ru: "\u0412\u0441\u0435\u0433\u043e \u0432\u044b\u0438\u0433\u0440\u0430\u043d\u043d\u044b\u0445 \u0442\u0443\u0440\u043d\u0438\u0440\u043e\u0432",
    de: "Gewonnene Turniere gesamt",
  },
  "Science tournaments won": {
    ru: "\u0412\u044b\u0438\u0433\u0440\u0430\u043d\u043d\u044b\u0435 \u0442\u0443\u0440\u043d\u0438\u0440\u044b (\u041d\u0430\u0443\u043a\u0430)",
    de: "Gewonnene Wissenschaftsturniere",
  },
  "Cienzar tournaments won": {
    ru: "\u0412\u044b\u0438\u0433\u0440\u0430\u043d\u043d\u044b\u0435 \u0442\u0443\u0440\u043d\u0438\u0440\u044b Cienzar",
    de: "Gewonnene Cienzar-Turniere",
  },
  "Dice tournaments won": {
    ru: "\u0412\u044b\u0438\u0433\u0440\u0430\u043d\u043d\u044b\u0435 \u0442\u0443\u0440\u043d\u0438\u0440\u044b (\u0421\u043b\u0443\u0447\u0430\u0439)",
    de: "Gewonnene Zufallsturniere",
  },
  "Game stats": { ru: "\u0418\u0433\u0440\u043e\u0432\u0430\u044f \u0441\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043a\u0430", de: "Spielstatistik" },
  "Science mode": { ru: "\u0420\u0435\u0436\u0438\u043c: \u041d\u0430\u0443\u043a\u0430", de: "Wissenschaftsmodus" },
  "Cienzar mode": { ru: "\u0420\u0435\u0436\u0438\u043c: Cienzar", de: "Cienzar-Modus" },
  "Dice mode": { ru: "\u0420\u0435\u0436\u0438\u043c: \u0421\u043b\u0443\u0447\u0430\u0439", de: "Zufallsmodus" },
  "CIMAX Science score": {
    ru: "\u041f\u043e\u043a\u0430\u0437\u0430\u0442\u0435\u043b\u044c CIMAX (\u041d\u0430\u0443\u043a\u0430)",
    de: "CIMAX Wissenschaftswert",
  },
  "Max game force": { ru: "\u041c\u0430\u043a\u0441\u0438\u043c\u0430\u043b\u044c\u043d\u0430\u044f \u0441\u0438\u043b\u0430 \u0438\u0433\u0440\u044b", de: "Maximale Spielstaerke" },
  "Max game level": { ru: "\u041c\u0430\u043a\u0441\u0438\u043c\u0430\u043b\u044c\u043d\u044b\u0439 \u0443\u0440\u043e\u0432\u0435\u043d\u044c \u0438\u0433\u0440\u044b", de: "Maximales Spiellevel" },
  "Max potency": { ru: "\u041c\u0430\u043a\u0441\u0438\u043c\u0430\u043b\u044c\u043d\u0430\u044f \u043c\u043e\u0449\u043d\u043e\u0441\u0442\u044c", de: "Maximale Potenz" },
  "Average game force": { ru: "\u0421\u0440\u0435\u0434\u043d\u044f\u044f \u0441\u0438\u043b\u0430 \u0438\u0433\u0440\u044b", de: "Durchschnittliche Spielstaerke" },
  "Average game level": { ru: "\u0421\u0440\u0435\u0434\u043d\u0438\u0439 \u0443\u0440\u043e\u0432\u0435\u043d\u044c \u0438\u0433\u0440\u044b", de: "Durchschnittliches Spiellevel" },
  "Average potency": { ru: "\u0421\u0440\u0435\u0434\u043d\u044f\u044f \u043c\u043e\u0449\u043d\u043e\u0441\u0442\u044c", de: "Durchschnittliche Potenz" },
  "Match history": { ru: "\u0418\u0441\u0442\u043e\u0440\u0438\u044f \u0438\u0433\u0440", de: "Spielverlauf" },
  "View stats": { ru: "\u041f\u043e\u0441\u043c\u043e\u0442\u0440\u0435\u0442\u044c \u0441\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043a\u0443", de: "Statistik ansehen" },
  "View all": { ru: "\u041f\u043e\u0441\u043c\u043e\u0442\u0440\u0435\u0442\u044c \u0432\u0441\u0435", de: "Alle ansehen" },
  "Refresh history": { ru: "\u041e\u0431\u043d\u043e\u0432\u0438\u0442\u044c \u0438\u0441\u0442\u043e\u0440\u0438\u044e", de: "Verlauf aktualisieren" },
  "News Messages": { ru: "\u041d\u043e\u0432\u043e\u0441\u0442\u043d\u043e\u0435 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435", de: "Nachrichtenmeldungen" },
  "Tournament Calendar": { ru: "\u041a\u0430\u043b\u0435\u043d\u0434\u0430\u0440\u044c \u0442\u0443\u0440\u043d\u0438\u0440\u043e\u0432", de: "Turnierkalender" },
  Messages: { ru: "\u0421\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u044f", de: "Nachrichten" },
  "Available now and scheduled for the future": {
    ru: "\u0414\u043e\u0441\u0442\u0443\u043f\u043d\u043e \u0441\u0435\u0439\u0447\u0430\u0441 \u0438 \u0437\u0430\u043f\u043b\u0430\u043d\u0438\u0440\u043e\u0432\u0430\u043d\u043e \u043d\u0430 \u0431\u0443\u0434\u0443\u0449\u0435\u0435",
    de: "Jetzt verfuegbar und fuer die Zukunft geplant",
  },
  "Log Out": { ru: "\u0412\u044b\u0439\u0442\u0438", de: "Ausloggen" },
  "Favorite mode": { ru: "\u041b\u044e\u0431\u0438\u043c\u044b\u0439 \u0440\u0435\u0436\u0438\u043c", de: "Lieblingsmodus" },
  Stats: { ru: "\u0421\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043a\u0430", de: "Statistik" },
  "Stats Error": { ru: "\u041e\u0448\u0438\u0431\u043a\u0430 \u0441\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043a\u0438", de: "Statistikfehler" },
};

const resolveSupportedLanguage = (value) => {
  const normalized = String(value || "")
    .trim()
    .toLowerCase();
  if (!normalized) return null;
  if (SUPPORTED_LANGUAGES.has(normalized)) return normalized;
  const baseLanguage = normalized.split(/[-_]/)[0];
  if (SUPPORTED_LANGUAGES.has(baseLanguage)) return baseLanguage;
  return null;
};

export const normalizeLanguage = (value) => resolveSupportedLanguage(value) || "es";

export const getStoredLanguage = () => {
  if (typeof window === "undefined") return "es";

  const storedLanguage = resolveSupportedLanguage(localStorage.getItem(LANGUAGE_STORAGE_KEY));
  if (storedLanguage) return storedLanguage;

  const browserLanguages = [
    window?.navigator?.language,
    ...(Array.isArray(window?.navigator?.languages) ? window.navigator.languages : []),
  ];

  for (const candidate of browserLanguages) {
    const detectedLanguage = resolveSupportedLanguage(candidate);
    if (detectedLanguage) return detectedLanguage;
  }

  return "es";
};

export const setStoredLanguage = (value) => {
  const nextLanguage = normalizeLanguage(value);
  if (typeof window !== "undefined") {
    localStorage.setItem(LANGUAGE_STORAGE_KEY, nextLanguage);
    document.documentElement.lang = nextLanguage;
    window.dispatchEvent(
      new CustomEvent("xima:languagechange", { detail: { language: nextLanguage } })
    );
  }
  return nextLanguage;
};

export const buildUserLanguagePreferencePayload = (value) => ({
  language: normalizeLanguage(value),
});

export const saveUserLanguagePreference = async (value, options = {}) => {
  const nextLanguage = normalizeLanguage(value);
  const apiClient = options.apiClient;
  const endpoint = options.endpoint || "/users/settings/language";
  const enabled = Boolean(options.enabled && apiClient?.patch);

  if (!enabled) {
    return { language: nextLanguage, skipped: true };
  }

  const response = await apiClient.patch(
    endpoint,
    buildUserLanguagePreferencePayload(nextLanguage)
  );
  return { language: nextLanguage, skipped: false, response };
};

export const getLocaleForLanguage = (value) =>
  LANGUAGE_LOCALES[normalizeLanguage(value)] || LANGUAGE_LOCALES.es;

export const getLanguageCopy = (language, copy, fallback = "") => {
  if (!copy || typeof copy !== "object") {
    return typeof copy === "string" ? copy : fallback;
  }

  const normalized = normalizeLanguage(language);
  return (
    copy[normalized] ||
    copy.en ||
    copy.es ||
    copy.ru ||
    copy.de ||
    fallback
  );
};

export const translatePair = (language, es, en) => {
  const normalized = normalizeLanguage(language);

  if (normalized === "es") return es;
  if (normalized === "en") return en;

  const extraTranslation = EXTRA_TRANSLATIONS[String(en || "").trim()];
  const centralTranslation = translateText(es, {
    language: normalized,
    fallbackEn: en,
    fallbackEs: es,
  });
  if (centralTranslation && centralTranslation !== es && centralTranslation !== en) {
    return centralTranslation;
  }
  if (normalized === "ru") {
    return extraTranslation?.ru || es;
  }
  if (normalized === "de") {
    return extraTranslation?.de || en;
  }
  return extraTranslation?.[normalized] || en;
};

const normalizeTournamentNameKey = (value) =>
  String(value || "")
    .trim()
    .replace(/\s+/g, " ")
    .toLowerCase();

const TOURNAMENT_NAME_TRANSLATIONS = new Map([
  [
    normalizeTournamentNameKey("Juego entre 4 jugadores eliges mover con o sin dados"),
    {
      en: "Game between 4 players, choose to move with or without dice",
      ru: "Игра между 4 игроками, можно ходить с кубиками или без них",
      de: "Spiel zwischen 4 Spielern, wähle mit oder ohne Würfel",
    },
  ],
  [
    normalizeTournamentNameKey("Juego entre 3 jugadores eliges mover con o sin dados"),
    {
      en: "Game between 3 players, choose to move with or without dice",
      ru: "Игра между 3 игроками, можно ходить с кубиками или без них",
      de: "Spiel zwischen 3 Spielern, wähle mit oder ohne Würfel",
    },
  ],
  [
    normalizeTournamentNameKey("Juego entre 2 jugadores eliges mover con o sin dados"),
    {
      en: "Game between 2 players, choose to move with or without dice",
      ru: "Игра между 2 игроками, можно ходить с кубиками или без них",
      de: "Spiel zwischen 2 Spielern, wähle mit oder ohne Würfel",
    },
  ],
  [
    normalizeTournamentNameKey("Juego entre 4 jugadores sin dados"),
    {
      en: "Game between 4 players without dice",
      ru: "Игра между 4 игроками без кубиков",
      de: "Spiel zwischen 4 Spielern ohne Würfel",
    },
  ],
  [
    normalizeTournamentNameKey("Juego entre 3 jugadores sin dados"),
    {
      en: "Game between 3 players without dice",
      ru: "Игра между 3 игроками без кубиков",
      de: "Spiel zwischen 3 Spielern ohne Würfel",
    },
  ],
  [
    normalizeTournamentNameKey("Juego entre 2 jugadores con dados"),
    {
      en: "Game between 2 players with dice",
      ru: "Игра между 2 игроками с кубиками",
      de: "Spiel zwischen 2 Spielern mit Würfeln",
    },
  ],
  [
    normalizeTournamentNameKey("Juego entre 4 jugadores con dados"),
    {
      en: "Game between 4 players with dice",
      ru: "Игра между 4 игроками с кубиками",
      de: "Spiel zwischen 4 Spielern mit Würfeln",
    },
  ],
  [
    normalizeTournamentNameKey("Juego entre 3 jugadores con dados"),
    {
      en: "Game between 3 players with dice",
      ru: "Игра между 3 игроками с кубиками",
      de: "Spiel zwischen 3 Spielern mit Würfeln",
    },
  ],
]);

export const localizeTournamentName = (language, tournamentName) => {
  const raw = String(tournamentName || "").trim();
  if (!raw) return "";

  const normalizedLanguage = normalizeLanguage(language);
  const translation = TOURNAMENT_NAME_TRANSLATIONS.get(normalizeTournamentNameKey(raw));
  if (translation) {
    if (normalizedLanguage === "es") return raw;
    return translation[normalizedLanguage] || translation.en || raw;
  }

  const defaultNameMatch = /^desafio creado por\s+(.+)$/i.exec(raw);
  if (defaultNameMatch) {
    const creatorName = String(defaultNameMatch[1] || "").trim() || "Jugador";
    if (normalizedLanguage === "en") return `Challenge created by ${creatorName}`;
    if (normalizedLanguage === "ru") return `Вызов создан ${creatorName}`;
    if (normalizedLanguage === "de") return `Herausforderung erstellt von ${creatorName}`;
  }

  return raw;
};
